import { render, staticRenderFns } from "./createDevoir.vue?vue&type=template&id=1f948d46&"
import script from "./createDevoir.vue?vue&type=script&lang=js&"
export * from "./createDevoir.vue?vue&type=script&lang=js&"
import style0 from "./createDevoir.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports